import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const HouseholdChartsDataContext = createContext();

const HouseholdChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.HOUSEHOLD_FAMILIES,
            url: 'governanceroom/dashboard/unifiedregistry/families/household'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  averagePeoplePerFamily: data?.indicators?.averagePeoplePerFamily ?? 0,
                  peoplePerRoom:
                      data?.indicators?.peoplePerRoom ?? 0,
                  averageRoomsPerFamily: data?.indicators?.averageRoomsPerFamily ?? 0,
                  averageBedsPerRoom: data?.indicators?.averageBedsPerRoom ?? 0
              },
              bedroomsPerHouse: data?.bedroomsPerHouse ?? [],
              familiesPerHouse: data?.familiesPerHouse ?? [],
              houseLocalization: data?.houseLocalization ?? [],
              peoplePerHouse: data?.peoplePerHouse ?? [],
              peoplePerHouseType: data?.peoplePerHouseType ?? [],
              roomsPerHouse: data?.roomsPerHouse ?? []
          }
        : {
              indicators: {
                  averagePeoplePerFamily: 0,
                  peoplePerRoom: 0,
                  averageRoomsPerFamily: 0,
                  averageBedsPerRoom: 0
              },
              bedroomsPerHouse: [],
              familiesPerHouse: [],
              houseLocalization: [],
              peoplePerHouse: [],
              peoplePerHouseType: [],
              roomsPerHouse: []
          };

    return (
        <HouseholdChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </HouseholdChartsDataContext.Provider>
    );
};

export default HouseholdChartsDataProvider;
